import { render } from "./CandidateSelectorModal.vue?vue&type=template&id=04eccacc"
import script from "./CandidateSelectorModal.vue?vue&type=script&lang=js"
export * from "./CandidateSelectorModal.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2845839839/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__